import request from '@/utils/request'

// 查询【请填写功能名称】列表
export function listVal(query) {
  return request({
    url: '/platform/val/list',
    method: 'get',
    params: query
  })
}

// 查询【请填写功能名称】详细
export function getVal(valId) {
  return request({
    url: '/platform/val/' + valId,
    method: 'get'
  })
}

// 新增【请填写功能名称】
export function addVal(data) {
  return request({
    url: '/platform/val',
    method: 'post',
    data: data
  })
}

// 修改【请填写功能名称】
export function updateVal(data) {
  return request({
    url: '/platform/val',
    method: 'put',
    data: data
  })
}

// 删除【请填写功能名称】
export function delVal(valId) {
  return request({
    url: '/platform/val/' + valId,
    method: 'delete'
  })
}

// 导出【请填写功能名称】
export function exportVal(query) {
  return request({
    url: '/platform/val/export',
    method: 'get',
    params: query
  })
}

// 根据attr_id获取集合
export function getListByAttrId(params) {
    return request({
        url: '/platform/val/getListByAttrId',
        method: 'get',
        params: params
    })
}

//通过attrId获取变种属性值集合
export function getBzztValListByAttrId(params) {
    return request({
        url: '/platform/val/getBzztValListByAttrId',
        method: 'get',
        params: params
    })
}




